import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import {
  Paper, Box, IconButton, Select, MenuItem, InputLabel, FormControl
} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';
import '../../styles/AppStyle.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAccountsFromAPI } from '../../Redux/AccountDucks';
import { listTemplatesAPI } from '../../Redux/TemplateDucks';
import { fetchFullCampaignsFromAPI } from '../../Redux/CampaignDucks';


export default function ReportCampaignPage() {
  const [templates, setTemplate] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState('');
  const [SelectedAccount, setSelectedAccount] = useState("0");
  const [SelectedTemplate, setSelectedTemplate] = useState(null);

  const dispatch = useDispatch()
  const accountList = useSelector(store => store.account.accounts)
  const templateList = useSelector(store => store.template.templates)
  const campaignList = useSelector(store => store.campaign.campaignReport)

  // On mount: fetch accounts only
  useEffect(() => {
    setLoading(true);
    dispatch(fetchAccountsFromAPI());
  }, [dispatch]);

  // When SelectedAccount changes: load templates and campaigns for that account
  useEffect(() => {
    setLoading(true);
    dispatch(listTemplatesAPI(SelectedAccount));
    dispatch(fetchFullCampaignsFromAPI(String(SelectedAccount)));
  }, [SelectedAccount, dispatch]);

  useEffect(() => {
    setTemplate(templateList);
    setLoading(false);
  }, [templateList]);

  useEffect(() => {
    setCampaigns(campaignList);
    setLoading(false);
  }, [campaignList]);

  const handleChangeOption = (event) => {
    const { value } = event.target;
    setSelectedAccount(value);
    setLoading(true);
    dispatch(listTemplatesAPI(String(value)));
    // Also fetch campaigns for the newly selected account immediately
    dispatch(fetchFullCampaignsFromAPI(String(value)));
  };

  const handleViewDetail = (campaign) => {
    setSelectedTemplate(campaign);
    //redirecto to detail page
    window.location.href = `/campaigns/analize/${campaign.id}`;
  };

  const filteredItems = campaigns.filter(
    item => (item.templateName && item.templateName.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase()))
  );

  const columns = [
    {
      name: 'Id',
      selector: row => row.id,
      sortable: true,
      maxWidth: "20px"
    },
    {
      name: 'Nombre',
      selector: row => row.name,
      sortable: true,
      grow: 2,
      maxWidth: "200px"
    },
    {
      name: 'Plantilla',
      selector: row => row.templateName,
      sortable: true,
      maxWidth: "300px",
      grow: 2,
    },
    {
      name: 'Número',
      selector: row => row.accountNumber,
      sortable: true,
      maxWidth: "200px"
    },
    {
      name: 'Estado',
      selector: row => row.status,
      sortable: true,
      maxWidth: "100px"
    },
    {
      name: 'Enviados',
      selector: row => row.send,
      sortable: true,
      maxWidth: "100px"
    },
    {
      name: 'Respondidos',
      selector: row => row.read ?? 0,
      sortable: true,
      maxWidth: "100px"
    },
    {
      name: 'Fecha de Creación',
      selector: row => row.createAt,
      sortable: true,
      maxWidth: "200px"
    },
    {
      name: 'Fecha de Envío',
      selector: row => row.sentAt,
      sortable: true,
      maxWidth: "200px"
    },
    {
      name: 'Ultima Actualizacion',
      selector: row => row.lastUpdate,
      sortable: true,
      maxWidth: "200px"
    },
  
    {
      name: 'Acciones',
      cell: row => (
        <Box>
          {row.status === "SENT" && (
      <IconButton onClick={() => handleViewDetail(row)} size="small" className="apple-button apple-tooltip">
        <VisibilityIcon fontSize="small" />
        <span className="tooltiptext">Ver Detalle</span>
      </IconButton>
    )}
        </Box>
      ),
    },
  ];

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <Box className="apple-card" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <div className="apple-search-container">
            <SearchIcon className="apple-search-icon" />
            <input
              type="text"
              placeholder="Buscar por Campaña o Plantilla"
              onChange={e => setFilterText(e.target.value)}
              className="apple-search-input"
              style={{ minWidth: "250px" }}
            />
          </div>
          <FormControl variant="outlined" className="apple-select" sx={{ ml: 2 }} fullWidth>
            <InputLabel id="business-line-label" sx={{ background: "#FFFF" }}>Cuenta de WhatsApp Business</InputLabel>
            <Select
              labelId="business-line-label"
              label="Línea de Negocio"
              value={SelectedAccount}
              onChange={handleChangeOption}
              size='small'
              sx={{ width: '200px' }}
            >
              <MenuItem value={"0"}>Todas</MenuItem>
              {accountList.map((option) => (
                <MenuItem key={option.id} value={option.id}>{option.number}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    );
  }, [filterText, SelectedAccount, accountList]);

  return (
    <div className="apple-container" >
      <Paper className="apple-card">
        <DataTable
          columns={columns}
          data={filteredItems}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 20, 30]}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          progressPending={loading}
          persistTableHead
          customStyles={customStyles}
        />
      </Paper>
    </div>
  );

}

const customStyles = {
  table: {
    style: {
      minWidth: '80vw',
      maxWidth: '90vw'
    },
  },
  headRow: {
    style: {
      backgroundColor: '#F2F2F7',
      borderBottom: 'none',
    },
  },
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: '600',
      color: '#86868B',
      textTransform: 'uppercase',
    },
  },
  cells: {
    style: {
      fontSize: '14px',
      color: '#1D1D1F',
    },
  },
};